const round = number => {
  if (!number || isNaN(number)) return null;
  return Math.round(number * 100) / 100;
};
module.exports = {
  isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  },
  numberToCurrency(input, showDigits = true) {
    if (typeof input == 'string') input = parseFloat(input);
    showDigits = showDigits == true || showDigits == 'true' ? true : false;
    if (input) {
      return (
        round(input).toLocaleString('de-DE', {
          minimumFractionDigits: showDigits ? 2 : 0,
          maximumFractionDigits: showDigits ? 2 : 0
        }) + ' €'
      );
    } else {
      if (showDigits) return '0,00 €';
      else return '0 €';
    }
  },
  formatCurrency(number, settingsStore) {
    return this.numberToCurrency(round(number), settingsStore.settings['Centbetraege']);
  },
  numberWithMaxFrictions(input, maxFrictions) {
    if (input) {
      return parseFloat(round(input)).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: maxFrictions
      });
    } else return null;
    /*return parseFloat(0).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: maxFrictions
      });*/
  },
  numberWithMaxFrictionsDE(input, maxFrictions) {
    if (input) {
      return parseFloat(round(input)).toLocaleString('de-DE', {
        minimumFractionDigits: 0,
        maximumFractionDigits: maxFrictions
      });
    }
  },
  deleteItemFromArray(array, findFunction) {
    const index = array.findIndex(findFunction);
    if (index == -1) return; // console.log('not found in array', array);
    array.splice(index, 1);
    return array;
  },
  deleteIndexFromArray(array, index) {
    array.splice(index, 1);
    return array;
  },
  germanDateToISODate(dateString) {
    const dateParts = dateString.split('.');
    var date = new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]), 0, 0, 0, 0);
    return date.toISOString();
  },
  germanDateToSQLDate(dateString) {
    const dateParts = dateString.split('.');
    return dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0];
  },
  browserDateToSQLDate(dateString) {
    if (dateString && dateString == '') return null;
    if (!dateString) return null;
    const dateParts = dateString.split('-');
    return dateParts[0] + '-' + dateParts[1] + '-' + dateParts[2];
  },
  SQLDateToGermanDate(dateString, textIfNull = '') {
    if (dateString)
      return new Date(dateString).toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    else return textIfNull;
  },
  SQLDateToBrowserDate(dateString) {
    if (!dateString) return null;
    return dateString.split('T')[0];
  },
  currentGermanDate() {
    return new Date().toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
  },
  currentBrowserDate() {
    const parts = new Date().toLocaleString('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' }).split('/');
    const retVal = parts[2] + '-' + parts[0] + '-' + parts[1];
    return retVal;
  },
  round,
  sortArray(array, property) {
    array.sort((a, b) => {
      /*
      if (a[property] < b[property]) {
        return -1;
      }
      if (a[property] > b[property]) {
        return 1;
      }
      return 0;*/
      return a[property].localeCompare(b[property]);
    });
  }
};
